export default 'Please enter a valid email address'
